import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, updateFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectFaqs } from '../../store/selectors/faqsNotesDocuments';
import Faqs from '../../components/Faqs';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/upLoadHelper'
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { clearFndFormData } from '../../store/actions/fndForm';

class ItemFaqs extends Component {
  componentDidMount() {
    const { item, onFetchFaqs,clearSearch} = this.props;
    this.props.clearFndFormData()
    onFetchFaqs(item.id);
    clearSearch()
  }

  onSave = async (faq) => {
    const {  item,onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments  } = this.props;
    let image=null

    if(faq.uploadType==="Image"&& faq.image && faq.image.length > 0){
        
      image =  await upload(faq.image[0])
      faq = faq = {...faq,image}
    }
      faq = {...faq, question: faq.question.trim()}
      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 11/10/2022
      // Jira ticket: JUN-3315
      // Comment: we made category as optional.
      if(faq && faq.issue) {
        faq = {...faq, issue: faq.issue.trim()}
      }
      if(faq && faq.linkTitle) {
        faq = {...faq, linkTitle: faq.linkTitle.trim()}
      }
      if(faq && faq.caption) {
        faq = {...faq, caption: faq.caption.trim()}
      }
    if(faq.id){
      let data = {
        "id": faq.id,
        "ItemId": item.id,
        "Name": 'Frequently Asked Questions',
        "Type": 'FAQS',
        "data": JSON.stringify(faq).toString(),
        "UserId": this.props.user.id
      }

      onUpdateFaqsNotesDocuments(data)

    }else{
      onSaveFaqsNotesDocuments(
        {
              ItemId: item.id,
              Name: 'Frequently Asked Questions',
              Type: 'FAQS',
              Data: JSON.stringify(faq).toString(),
              UserId: this.props.user.id
            }
      )
        }

  }

  render() {
    const { faqs, onDeleteFaqsNotesDocuments,setSearch, loader } = this.props;
    return (
      loader ? <Loader /> :
      <Faqs
        faqs={faqs}
        onSaveFaq={ faq => this.onSave(faq)}
        onDeleteFaq={ faq => {onDeleteFaqsNotesDocuments({...faq,Type:'FAQS'})}}

        onSearch={e => setSearch({ faqs: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  faqs: selectFaqs(state),
  formOptions: selectFormOptions(state),
  loader:selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqs: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch,
  clearFndFormData

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemFaqs);
